import { store } from "../store";
import { ddiPhoneMask } from "./masks";

export const getClientName = (phone, messages) => {
  const state = store.getState()
  const client = state.whatsappChat.allClientsData?.find((client) => client.phone === phone);

  return client?.name || messages?.find((item) => !item.fromMe && item.pushName !== '')?.pushName || ddiPhoneMask(phone);
}
